/**
 * ErrorBoundary global.
 * Estructura DOBLE: uno fuera y otro dentro del Suspense.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { DefaultErrorFallback } from './DefaultErrorFallback';

type Props = { children: ReactNode; fallback?: (err: Error, reset: () => void) => ReactNode };
type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError && this.state.error) {
      return this.props.fallback ? this.props.fallback(this.state.error, this.reset) : <DefaultErrorFallback error={this.state.error} reset={this.reset} />;
    }
    return this.props.children;
  }
}
